function SendVibration(type = 'light') {
	try {
		window?.ReactNativeWebView?.postMessage(
			JSON.stringify({
				type: 'haptics',
				data: type,
			})
		);
	} catch (e) {
		console.log(e);
	}
}

export default SendVibration;
